import { Component, ElementRef, Input, ViewEncapsulation, inject } from '@angular/core';
import {SharedSafePipe} from '@shared/pipes/shared-safe.pipe';
import {TranslateService} from '@ngx-translate/core';
import {SharedImageService} from '@shared/services/shared-image.service';
import {AlertController} from "@ionic/angular";

@Component({
  selector: 'app-shared-user-html',
  templateUrl: './shared-user-html.component.html',
  styleUrls: ['./shared-user-html.component.scss'],
  imports: [SharedSafePipe],
  standalone: true,
  encapsulation: ViewEncapsulation.None,
})
export class SharedUserHtmlComponent {
  private _alertService = inject(AlertController);
  private _imageService = inject(SharedImageService);
  private _element = inject(ElementRef);
  private _translateService = inject(TranslateService);

  @Input() set html(value: string | null | undefined) {
    this._html = value;
    setTimeout(() => this._addImageEventListeners());
    setTimeout(() => this._addAnchorEventListeners());
  }

  get html(): string | null | undefined {
    return this._html;
  }

  private _html: string | null | undefined;

  // Image zoom popup
  private _addImageEventListeners(): void {
    const images = this._element.nativeElement.querySelectorAll('img');
    images.forEach((img: HTMLElement) => {
      img.addEventListener('click', (event: Event) => {
        const target = event.target as HTMLImageElement;
        const imageName =
          target.getAttribute('alt') ||
          target.getAttribute('title') ||
          this._translateService.instant('GENERAL.DEFAULT_IMAGE');
        this._imageService.openModalImage(
          target.getAttribute('src') || '',
          imageName
        );
      });
    });
  }

  // External link warning
  private _addAnchorEventListeners(): void {
    const anchors = this._element.nativeElement.querySelectorAll('a');
    anchors.forEach((anchor: HTMLElement) => {
      anchor.addEventListener('click', (event: Event) => {
        const url = anchor.dataset['href'] ?? anchor.dataset['http'];
        if (!!url) {
          event.preventDefault();
          this._alertService.create({
            header: this._translateService.instant('GENERAL.EXTERNAL_LINK_ALERT.MESSAGE'),
            message: url,
            buttons: [
              {
                text: this._translateService.instant('GENERAL.EXTERNAL_LINK_ALERT.CANCEL'),
                handler: () => {
                }
              },
              {
                text: this._translateService.instant('GENERAL.EXTERNAL_LINK_ALERT.CONFIRM'),
                handler: () => {
                  window.open(url, '_blank');
                }
              }
            ]
          }).then((popup) => popup.present());
        }
      })
    })
  }
}
